export default {"src":"/_next/static/media/trazado-pink.4e5f8d42.svg","height":45,"width":76,"blurWidth":0,"blurHeight":0};